/** @jsx jsx */
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import ProducerPage from '../components/ProducerPage/ProducerPage';
import { resolve } from '../helpers/path';

export default function ProducerTemplate({
  data: {
    event,
    producer,
    previous,
    next,
    site: { siteMetadata },
  },
  pageContext,
  location,
  navigate,
}) {
  const { paths, segments } = pageContext;
  return (
    <ProducerPage
      {...pageContext}
      // Make sure the page is remounted on a different href (i.e. a different query).
      // QUESTION: Why is this actually necessary? Because of the page's state?
      key={location.href}
      event={event}
      producer={producer}
      getProductUrl={product =>
        resolve([
          paths.exhibitors,
          product.exhibitor?.slug,
          segments.products,
          product.slug,
        ])
      }
      products={producer && producer.products}
      previous={previous}
      next={next}
      siteTitle={siteMetadata.title}
      location={location}
      navigate={navigate}
    />
  );
}

export const pageQuery = graphql`
  query ProducerTemplate($id: String!, $previousId: String, $nextId: String) {
    producer(id: { eq: $id }) {
      ...ProducerPage
      event {
        ...ProducerPage_Event
      }
    }
    previous: producer(id: { eq: $previousId }) {
      ...ChangeProducerLink
    }
    next: producer(id: { eq: $nextId }) {
      ...ChangeProducerLink
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`;
